/**
 * @template TElement
 * @type {JQuery<TElement extends Node> | jQuery | HTMLElement}
 */
let _$body;

/**
 * @template TElement
 * @type {JQuery<TElement extends Node> | jQuery | HTMLElement}
 */
let _$window;

/**
 * @template TElement
 *
 * @return {JQuery<TElement extends Node> | jQuery | HTMLElement}
 */
export function $_body() {
  return _$body || (_$body = $('body'));
}

/**
 * @template TElement
 *
 * @return {JQuery<TElement extends Node> | jQuery | HTMLElement}
 */
export function $_window() {
  return _$window || (_$window = $(window));
}
